module.exports = new __parcel__URL__("28484_sq.f311429c.jpg").toString();